import { get, patch } from './client';
import { ROUTES } from './config';
import type { ApiEnvelope, Company } from '@/types/types';

export const companyApi = {
    get: () => get<ApiEnvelope<Company>>(ROUTES.COMPANY),
    update: (payload: Partial<Company>) =>
        patch<ApiEnvelope<Company>>(ROUTES.COMPANY, payload),
};
